import { render, staticRenderFns } from "./index05.vue?vue&type=template&id=b7011fbc&scoped=true&"
import script from "./index05.vue?vue&type=script&lang=js&"
export * from "./index05.vue?vue&type=script&lang=js&"
import style0 from "./index05.vue?vue&type=style&index=0&id=b7011fbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7011fbc",
  null
  
)

export default component.exports